import React, { useEffect, useState } from "react";
import { Box, Button, Grid } from "@mui/material";
import { ResourceLinks } from "../../../../constants";
import { makeArrayRandom } from "../../../../utils/learner";
import { useSelector } from "../../../../store";

export default function WebMatchTextSelectionImgToTxt({ question, onAnswer = () => {} }) {
    const questionData = question;
    const learnerState = useSelector((state) => state.learner || {});
    const data = learnerState?.details?.testLevel === "vfh" ? questionData?.vfh : questionData?.acsf4;
    const imagesResources = ResourceLinks.llnQuizImage;

    const [categories, setCategories] = useState(Object.keys(data['imageToText']).filter((key) => key !== "image"));
    const [selectedOptions, setSelectedOptions] = useState(
        categories.reduce((acc, category) => ({ ...acc, [category]: "" }), {})
    );
    const [isOptionRandom, setIsOptionRandom] = useState(false);

    // every time question change we will set to reset needed to reset
    useEffect(() => {
        setIsOptionRandom(false);
        setCategories(Object.keys(data['imageToText']).filter((key) => key !== "image"));
    }, [question, 
        data
    ]);

    const handleSelect = (category, option) => {
        setIsOptionRandom(true);
        setSelectedOptions((prev) => ({
            ...prev,
            [category]: option,
        }));
        logSelections({ ...selectedOptions, [category]: option });
    };

    const logSelections = (currentSelections) => {
        const formattedSelections = categories.reduce((acc, category) => {
            acc[category] = currentSelections[category];
            return acc;
        }, {});

        // checking if all answer so that we can make next screen
        const answerKeys = Object.keys(formattedSelections);
        let canProceed = false;
        answerKeys.map((key) => {
            if (formattedSelections[key] !== "" && formattedSelections[key] !== null) {
                canProceed = true;
            }
            return formattedSelections[key];
        });
        // trigger events for checking if can next button enabled
        onAnswer({
            canProceed,
            answer: formattedSelections,
        });
    };

    return (
        <Box
            sx={{
                textAlign: "center",
                padding: "20px",
                backgroundColor: "white",
            }}
        >
            <Box
                sx={{
                    // width: "100%",
                    width: "900px",
                    margin: "0 auto",
                    padding: "0 20px",
                    boxSizing: "border-box",
                }}
            >
                <Box
                    sx={{
                        width: data.imageDivWidth,
                        display: "flex",
                        justifyContent: "space-between",
                        marginBottom: "20px",
                        overflow: "hidden",
                    }}
                >
                    {/* singe and multiple image logic */}
                    {data.image ?
                        <Box component="img"
                            src={`${imagesResources}${data.image}`}
                            alt="Main visual"
                            sx={{ width: "100%", height: "auto" }}
                        /> : 
                         data.images.map((image, imageIndex) => (
                            <Box key={imageIndex}>
                                <Box component="img"
                                    src={`${imagesResources}${image.value}`}
                                    alt={image.value}
                                    sx={{ marginBottom: "10px", height: "150px" }}
                                />
                                <p style={{
                                    fontWeight: "bold",
                                    fontSize: data.fontSize,
                                }}>{image.info}</p>
                                {categories.map((category, index) => (
                                    imageIndex === index && 
                                        <Grid
                                            item
                                            xs={12 / categories.length}
                                            key={index}
                                            sx={{
                                                display: "flex",
                                                flexDirection: "column",
                                                alignItems: "center",
                                            }}
                                        >
                                            {data['imageToText'][category].map((option, i) => (
                                                <Button
                                                    key={i}
                                                    variant="contained"
                                                    sx={{
                                                        marginBottom: "10px",
                                                        // width: "100%",
                                                        width: "160px",
                                                        height: "50px",
                                                        cursor: "pointer",
                                                        userSelect: "none",
                                                        color: "black",
                                                        fontSize: data.fontSize,
                                                        backgroundColor:
                                                            selectedOptions[category] === option
                                                                ? "rgb(175, 226, 62)"
                                                                : "rgb(218, 218, 218)",
                                                        borderBottom: `10px solid ${
                                                            selectedOptions[category] === option
                                                                ? "rgb(99, 151, 41)"
                                                                : "rgb(128, 128, 128)"
                                                        }`,
                                                        fontWeight: "bold",
                                                        "&.MuiButton-contained": {
                                                            backgroundColor:
                                                                selectedOptions[category] ===
                                                                option
                                                                    ? "rgb(175, 226, 62)"
                                                                    : "rgb(218, 218, 218)",
                                                            boxShadow: "none",
                                                        },
                                                        "&:hover.MuiButton-contained": {
                                                            backgroundColor:
                                                                selectedOptions[category] ===
                                                                option
                                                                    ? "rgb(175, 226, 62)"
                                                                    : "rgb(218, 218, 218)",
                                                            boxShadow: "none",
                                                        },
                                                    }}
                                                    onClick={() =>
                                                        handleSelect(category, option)
                                                    }
                                                >
                                                    {option}
                                                </Button>
                                            ))}
                                        </Grid>
                                ))}
                            </Box>
                         ))
                    }
                </Box>

                {/* This bottom will be used if image is single */}
                {data.image && 
                    <Grid container spacing={2}>
                        {categories.map((category, index) => {
                            let options = !isOptionRandom ? makeArrayRandom(data['imageToText'][category]) : data['imageToText'][category];
                            return (
                                <Grid
                                    item
                                    xs={12 / categories.length}
                                    key={index}
                                    sx={{
                                        display: "flex",
                                        flexDirection: "column",
                                        alignItems: "center",
                                    }}
                                >
                                    {options.map((option, i) => (
                                        <Button
                                            key={i}
                                            variant="contained"
                                            sx={{
                                                marginBottom: "10px",
                                                // width: "100%",
                                                width: "160px",
                                                height: "50px",
                                                fontSize: "18px",
                                                cursor: "pointer",
                                                userSelect: "none",
                                                color: "black",
                                                backgroundColor:
                                                    selectedOptions[category] === option
                                                        ? "rgb(175, 226, 62)"
                                                        : "rgb(218, 218, 218)",
                                                borderBottom: `10px solid ${
                                                    selectedOptions[category] === option
                                                        ? "rgb(99, 151, 41)"
                                                        : "rgb(128, 128, 128)"
                                                }`,
                                                fontWeight: "bold",
                                                "&.MuiButton-contained": {
                                                    backgroundColor:
                                                        selectedOptions[category] ===
                                                        option
                                                            ? "rgb(175, 226, 62)"
                                                            : "rgb(218, 218, 218)",
                                                    boxShadow: "none",
                                                },
                                                "&:hover.MuiButton-contained": {
                                                    backgroundColor:
                                                        selectedOptions[category] ===
                                                        option
                                                            ? "rgb(175, 226, 62)"
                                                            : "rgb(218, 218, 218)",
                                                    boxShadow: "none",
                                                },
                                            }}
                                            onClick={() =>
                                                handleSelect(category, option)
                                            }
                                        >
                                            {option}
                                        </Button>
                                    ))}
                                </Grid>
                            )
                        })}
                    </Grid>
                }
            </Box>
        </Box>
    );
};
